export default function or(...args: any) {
  return args.some((arg: any) => arg);
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    or: typeof or;
  }
}
